var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Input } from "semantic-ui-react";
var EditCommentModal = /** @class */ (function (_super) {
    __extends(EditCommentModal, _super);
    function EditCommentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.updateComment = function (_, data) {
            _this.setState({
                comment: data.value
            }, function () {
                _this.props.setFishFormState(function () {
                    return {
                        comment: data.value
                    };
                }, function () {
                    _this.props.setIshFormState(function () {
                        return {
                            comment: data.value
                        };
                    }, function () {
                        _this.props.setChromogenFormState(function () {
                            return {
                                comment: data.value
                            };
                        }, function () {
                            _this.props.setSecondaryIfFormState(function () {
                                return {
                                    comment: data.value
                                };
                            }, function () {
                                _this.props.setEncoderFormState(function () {
                                    return {
                                        comment: data.value
                                    };
                                });
                            });
                        });
                    });
                });
            });
        };
        _this.state = {
            comment: _this.props.initialComment
        };
        return _this;
    }
    EditCommentModal.prototype.render = function () {
        return React.createElement(Input, { onChange: this.updateComment, value: this.state.comment, 
            // size={"massive"}
            fluid: true });
    };
    return EditCommentModal;
}(React.PureComponent));
export default EditCommentModal;
//# sourceMappingURL=EditCommentModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/EditCommentModal.js
// module id = 1155
// module chunks = 0